import { Link } from "react-router-dom";
import '../../resources/css/login-link.css';

export default function LoginLink() {

    return (
        <div className="login-link">
            <Link to="/login">
                <img src="/favicon.png" alt="login"></img>
            </Link>
        </div>
    )
}
